export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Electricians, HVAC and refrigeration technicians, facilities and maintenance technicians, engineers and students who work in or want to move into data centers and mission-critical facilities.',
  ],
  ['Content depth?', 'From fundamentals to professional-level operations, maintenance and safety.'],
  [
    'International?',
    'Yes. Based on internationally used concepts and terminology; always follow local codes, site procedures and manufacturer instructions.',
  ],
  ['Format?', 'Professional PDF files with instant access.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
